class ResizingSelect {
	constructor(config) {
		this.helperElement = 'helper-element';

		this.config = Object.assign({
			scope: '[data-select="resizing"]',
			select: 'select',
			helper: `.${this.helperElement}`
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initSelect();
		this.initEventListeners();
	}

	initEventListeners() {
		this.$scope.off('.select')
			.on('change.select', this.config.select, this.initResize.bind(this))
		;
	}

	initSelect() {
		this.$scope.each(function (index, element) {
			let $scope = $(element);
			if ($scope.find(this.config.helper).length === 0) {
				let selectedOption = $scope.find('option:selected');
				$scope.append(`<span class="${this.helperElement}" aria-hidden="true">${selectedOption.html()}</span>`);

				let $helper = $scope.find(this.config.helper);
				this.resize($scope, $helper.outerWidth());
			}
		}.bind(this));
	}

	initResize(event) {
		let $target = $(event.currentTarget);
		let $scope = $target.closest(this.config.scope);

		let selectedOption = $target.find('option:selected');
		let $helper = $scope.find(this.config.helper);
		if ($helper.length > 0) {
			$helper.html(selectedOption.html());
			this.resize($scope, $helper.outerWidth());
		}
	}

	resize($scope, width) {
		$scope.find(this.config.select).width(width);
	}
}

export default ResizingSelect;
